import '../Button/button.css';

const Button = (props) => {
  const { children, color } = props;
  const classNameBtn = `button_color_${color} `;

  return <button className={classNameBtn}>{children}</button>;
};
export default Button;
